import { useState } from "react";
import {
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Formik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";

export default function VehicleCalibrationRemaindarBoard(openDialogByDefault = false) {
  const [openDialog, setOpenDialog] = useState(openDialogByDefault);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const handleSnackbarClose = () => setOpenSnackbar(false);
  const handleDialogToggle = () => setOpenDialog(!openDialog);
  const navigate = useNavigate();
  const initialValues = {
    feedbacktitle: "",
    feedbackcontent: "",
  };

  const validationSchema = Yup.object({
    feedbacktitle: Yup.string().required("Title is required"),
    feedbackcontent: Yup.string().required("Details are required"),
  });

  const handleGoToSettings = () => {
    navigate("/managesettings/ManageSettings");
  };
  return (
    <>
      <Dialog open={openDialog} onClose={handleDialogToggle} maxWidth="sm" fullWidth>
        <DialogTitle
          sx={{
            background: "linear-gradient(45deg, #0abb87, #1e4b8c)",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            pr: 1,
          }}
        >
          CALIBRATING VEHICLE DASHBOARD ODOMETER WITH GPS ODOMETER
          <IconButton
            aria-label="close"
            onClick={handleDialogToggle}
            sx={{
              color: "#fff",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}

        >
          <DialogContent dividers>
            <Typography variant="body1" gutterBottom>
              This is a gentle reminder to update the vehicle odometer with GPS odometer to ensure both match.
            </Typography>
            <Typography variant="body2" component="ol" sx={{ pl: 2 }}>
              <li>Call the driver when the vehicle is parked and the engine is OFF.</li>
              <li>Ask the driver to read the odometer with ignition ON (engine still OFF).</li>
              <li>Go to <b>Manage Settings &gt; Asset</b>.</li>
              <li>Click <b>Edit Asset Details</b>.</li>
              <li>Select the vehicle plate number.</li>
              <li>Enter the dashboard odometer reading exactly as given by the driver.</li>
              <li>Double check the value is accurate, then click <b>Submit</b>.</li>
              <li>Repeat this process for each vehicle in your fleet.</li>
            </Typography>
            <Typography>
              <br />
              <li>
                Please click the link to be redirect to Mangage Settings {" "}
                <span
                  onClick={handleGoToSettings}
                  style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
                >
                  Manage Settings &gt; Asset
                </span>

              </li>
            </Typography>
            <Typography variant="body2" sx={{ mt: 2 }}>
              <b>Important note: This has to be done every month.</b>
            </Typography>
          </DialogContent>
        </Formik>
      </Dialog>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
      </Snackbar>
    </>
  );
}